// extracted by mini-css-extract-plugin
export default {"NoteDetailsButton":"NoteDetailsButton---Fv03O","NoteDetailsShowMoreButton":"NoteDetailsShowMoreButton---fC1Gv","NotesListMCLCell":"NotesListMCLCell---yeWq_"};